import { useMemo } from "react";
import { usePreference } from "../usePreference";
import { LOCAL_NEWS_REGION } from "../../constants/userPreferences";
import { REGION_BY_PREFERENCE, DEFAULT_REGION } from "../../constants/regions";
import log from "../../utils/logger/library";

export default function useLocalNewsRegion() {
    const { value, update, isExplicitlySet, isLoading } =
        usePreference(LOCAL_NEWS_REGION);
    let region = REGION_BY_PREFERENCE[value];
    if (!region) {
        region = REGION_BY_PREFERENCE[DEFAULT_REGION.preference];
        log.error(`(useLocalNewsRegion) Unknown region "${value}"`);
    }

    const updateRegion = useMemo(
        () => (region) => {
            if (!REGION_BY_PREFERENCE[region]) {
                log.error(`(useLocalNewsRegion) Unknown region "${value}"`);
                return;
            }
            update(region);
            if (
                window.CBC &&
                window.CBC.APP &&
                window.CBC.APP.PubSub &&
                window.CBC.APP.PubSub.publish
            ) {
                window.CBC.APP.PubSub.publish(
                    "regionChange",
                    REGION_BY_PREFERENCE[region]
                );
            }
        },
        [update]
    );

    return {
        region,
        update: updateRegion,
        isExplicitlySet,
        isLoading,
    };
}
